import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './produktgruppe.list-view.html',
    styleUrls: ['./produktgruppe.list-view.scss']
})
export class ProduktgruppeListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
